import React, { ReactNode } from 'react';

export interface SectionHeaderProps {
  label: string;
  title: ReactNode;
  description: ReactNode;
  isVisible?: boolean;
  labelColor?: 'pink' | 'mint' | 'amber' | 'ink';
}

const colorMap = {
  pink: 'bg-brand-pink',
  mint: 'bg-brand-mint',
  amber: 'bg-brand-amber',
  ink: 'bg-foreground/80',
};

export function SectionHeader({ 
  label, 
  title, 
  description, 
  isVisible = true,
  labelColor = 'pink'
}: SectionHeaderProps) {
  return (
    <div className="max-w-3xl mb-10 md:mb-14">
      <div
        className={`flex items-center gap-2 mb-4 opacity-0 ${isVisible ? 'animate-fade-up' : ''}`}
        style={{ animationDelay: '0.05s' }}
      >
        <span className={`w-1.5 h-1.5 rounded-full ${colorMap[labelColor]}`} />
        <span className="text-section-eyebrow text-foreground-eyebrow">
          {label}
        </span>
      </div>

      <h2
        className={`font-display text-heading md:text-display-sm text-foreground text-balance mb-6 opacity-0 ${isVisible ? 'animate-fade-up' : ''}`}
        style={{ animationDelay: '0.1s' }}
      >
        {title}
      </h2>

      <p
        className={`font-body text-body text-foreground-tertiary leading-relaxed text-pretty opacity-0 ${isVisible ? 'animate-fade-up' : ''}`}
        style={{ animationDelay: '0.15s' }}
      >
        {description}
      </p>
    </div>
  );
}

export default SectionHeader;
